"use client";

import * as React from "react";

import { HeroUIProvider } from "@heroui/system";

function HeroProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = React.useState<"light" | "dark">("dark");

  const setHtmlElementTheme = (theme: "light" | "dark") => {
    if (theme === "dark") {
      document.documentElement.classList.remove("light");
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
      document.documentElement.classList.add("light");
    }
  };

  React.useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const newTheme = mediaQuery.matches ? "dark" : "light";

    setTheme(newTheme);
    setHtmlElementTheme(newTheme);

    const handler = (e: MediaQueryListEvent) => {
      const newTheme = e.matches ? "dark" : "light";
      setTheme(newTheme);
      setHtmlElementTheme(newTheme);
    };

    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return (
    <HeroUIProvider className={`${theme} text-foreground bg-background`}>
      {children}
    </HeroUIProvider>
  );
}

export default HeroProvider;
